import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  const _component_van_divider = _resolveComponent("van-divider");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_form = _resolveComponent("van-form");
  const _component_CodeDataPickerCpt = _resolveComponent("CodeDataPickerCpt");
  const _component_PopupDateTimeCpt = _resolveComponent("PopupDateTimeCpt");
  const _component_CustomerQuery2Cpt = _resolveComponent("CustomerQuery2Cpt");
  const _component_PageNavBackLayoutCpt = _resolveComponent("PageNavBackLayoutCpt");
  return _openBlock(), _createBlock(_component_PageNavBackLayoutCpt, null, {
    default: _withCtx(() => [_createVNode(_component_van_form, {
      onSubmit: $options.onSubmit
    }, {
      default: _withCtx(() => [_createVNode(_component_van_cell_group, null, {
        default: _withCtx(() => [_createVNode(_component_van_field, {
          modelValue: $data.customer.chnName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.customer.chnName = $event),
          readonly: "",
          clickable: "",
          required: "",
          "right-icon": "search",
          name: "customerId",
          label: "客户姓名",
          placeholder: "客户姓名",
          rules: [{
            required: true,
            message: '请查询客户'
          }],
          onClick: $options.onSelectCustomerClick,
          onClickRightIcon: $options.onSelectCustomerClick
        }, null, 8, ["modelValue", "onClick", "onClickRightIcon"]), _createVNode(_component_van_field, {
          modelValue: $data.form.visitTime,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.form.visitTime = $event),
          readonly: "",
          clickable: "",
          required: "",
          name: "visitTime",
          label: "拜访时间",
          placeholder: "拜访时间",
          rules: [{
            required: true,
            message: '请选择拜访时间'
          }],
          onClick: _cache[2] || (_cache[2] = $event => $options.onPopupDateTimeSelectClick('visitTime'))
        }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
          modelValue: $data.form.visitType.text,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.form.visitType.text = $event),
          readonly: "",
          clickable: "",
          required: "",
          name: "visitType",
          label: "拜访类型",
          placeholder: "拜访类型",
          rules: [{
            required: true,
            message: '请选择拜访类型'
          }],
          onClick: _cache[4] || (_cache[4] = $event => $options.onPickerCodeSelectClick('visitType', 'customerVisitType'))
        }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
          modelValue: $data.form.visitAction.text,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.form.visitAction.text = $event),
          readonly: "",
          clickable: "",
          required: "",
          name: "visitAction",
          label: "拜访动作",
          placeholder: "拜访动作",
          rules: [{
            required: true,
            message: '请选择拜访动作'
          }],
          onClick: _cache[6] || (_cache[6] = $event => $options.onPickerCodeSelectClick('visitAction', 'customerVisitAction'))
        }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
          modelValue: $data.form.visitContent,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.form.visitContent = $event),
          autosize: "",
          rows: "1",
          type: "textarea",
          name: "visitContent",
          label: "拜访内容",
          placeholder: "拜访内容"
        }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
          modelValue: $data.form.nextVisitTime,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.form.nextVisitTime = $event),
          readonly: "",
          clickable: "",
          name: "nextVisitTime",
          label: "下次拜访时间",
          placeholder: "下次拜访时间",
          rightIcon: $options.getRightIcon('nextVisitTime'),
          onClick: _cache[9] || (_cache[9] = $event => $options.onPopupDateTimeSelectClick('nextVisitTime')),
          onClickRightIcon: _cache[10] || (_cache[10] = $event => $options.onRightIconClick('nextVisitTime'))
        }, null, 8, ["modelValue", "rightIcon"])]),
        _: 1
      }), _createVNode(_component_van_divider), _createVNode(_component_van_button, {
        style: {
          "width": "100%"
        },
        type: "primary",
        "native-type": "submit",
        loading: $data.btnLoading
      }, {
        default: _withCtx(() => [_createTextVNode(" 保存 ")]),
        _: 1
      }, 8, ["loading"])]),
      _: 1
    }, 8, ["onSubmit"]), _createVNode(_component_CodeDataPickerCpt, {
      ref: "CodeDataPickerCpt",
      onOnSelectedChange: $options.onPickerCodeSelected
    }, null, 8, ["onOnSelectedChange"]), _createVNode(_component_PopupDateTimeCpt, {
      ref: "PopupDateTimeCpt",
      type: "datetime",
      onOnSelectedChange: $options.onDateTimeSelectedChange
    }, null, 8, ["onOnSelectedChange"]), _createVNode(_component_CustomerQuery2Cpt, {
      ref: "CustomerQuery2Cpt",
      onSelected: $options.onCustomerSelected
    }, null, 8, ["onSelected"])]),
    _: 1
  });
}